/*
 * VQ Conversion-Badges (PDP)
 *
 * Haelt das Lager-Badge an der gewaehlten Variante. Der Verkaufszaehler
 * ist produktweit und braucht kein Update.
 *
 * Hoert auf PUB_SUB_EVENTS.variantChange (das Event, das product-info.js
 * tatsaechlich sendet) und zusaetzlich auf das alte DOM-Event
 * "variant:change", damit nichts bricht, falls das irgendwo noch gefeuert
 * wird.
 */
if (!customElements.get('vq-conversion-badges')) {
  customElements.define(
    'vq-conversion-badges',
    class VqConversionBadges extends HTMLElement {
      connectedCallback() {
        this.badge = this.querySelector('[data-vq-stock]');
        const dataEl = this.querySelector('[data-vq-stock-data]');
        if (!this.badge || !dataEl) return;

        try {
          this.config = JSON.parse(dataEl.textContent);
        } catch (error) {
          return;
        }

        this.onLegacyEvent = (event) => {
          const id = event.detail?.variant?.id;
          if (id) this.update(id);
        };
        document.addEventListener('variant:change', this.onLegacyEvent);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            // Quick-Add-Modals auf derselben Seite senden dasselbe Event.
            const sectionId = event?.data?.sectionId;
            if (sectionId && this.dataset.sectionId && String(sectionId) !== this.dataset.sectionId) return;
            const id = event?.data?.variant?.id;
            if (id) this.update(id);
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('variant:change', this.onLegacyEvent);
        if (this.unsubscribe) this.unsubscribe();
      }

      update(variantId) {
        const variant = this.config.variants[String(variantId)];
        if (!variant) return;

        let state = 'ok';
        if (!variant.available) {
          state = 'hidden';
        } else if (variant.managed && variant.qty > 0 && variant.qty <= this.config.threshold) {
          state = 'low';
        }

        this.badge.className = `vq-stock-badge vq-stock-badge--${state}`;
        this.badge.innerHTML = this.buildHtml(state, variant.qty);
      }

      buildHtml(state, qty) {
        if (state === 'hidden') return '';

        const dot = `<span class="vq-stock-badge__dot vq-stock-badge__dot--${state}" aria-hidden="true"></span>`;
        let label;
        if (state === 'low') {
          label =
            qty <= this.config.qtyThreshold
              ? `<strong>Nur noch ${qty} Stück auf Lager</strong>`
              : '<strong>Nur noch wenige Stücke auf Lager</strong>';
        } else {
          label = `<strong>${this.config.inStockLabel}</strong>`;
        }

        return `${dot}<span class="vq-stock-badge__inner">${label}<span class="vq-stock-badge__sep" aria-hidden="true">·</span><span class="vq-stock-badge__delivery">${this.config.deliveryLabel}</span></span>`;
      }
    }
  );
}
